import { render, staticRenderFns } from "./VasionContextMenu.vue?vue&type=template&id=b8a34ad0"
import script from "./VasionContextMenu.vue?vue&type=script&lang=js"
export * from "./VasionContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports